// extracted by mini-css-extract-plugin
export default {"gridTable":"style_gridTable__Bpz+Q"};